<template>
  <div v-if="translations.buttons && translations.info">
    <h3>{{ defineTitle }}</h3>
    <h1 class="p-3 mb-2 bg-warning text-white">
      {{ confirm.data }}
    </h1>

    <div class="col-12">
      <button class="btn btn-danger m-2" @click="changeToolSelected(null)">
        {{ translations.buttons.btn_cancel }}
      </button>
      <button class="btn btn-primary m-2" @click="confirmDelete()">
        {{ translations.buttons.btn_caonfirm }}
      </button>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  export default {
    name: 'ToolConfirmDelete',
    computed: {
      ...mapState(['confirm', 'translations']),
      defineTitle() {
        if (this.translations.info && this.translations.activity) {
          let result = this.translations.info.confirm_delete
          switch (this.confirm.type) {
            case 'activity':
              result += this.translations.activity.name
              break
            case 'event':
              result += this.translations.event.name
              break
          }
          return result + '?'
        }
      },
    },
    methods: {
      ...mapActions(['confirmDelete', 'changeToolSelected']),
    },
  }
</script>

<style></style>
